
import './style.css';

import Translations from '../../data/Translations';
import GalleryArray from '../../data/Gallery';
import LazyImage from '../../components/LazyImage/LazyImage';
import GalleryModal from './GalleryModal';

const Gallery = ({ currentLanguage }) => {
    return (
        <>
            <section id="gallery" class="gallery section-bg">
                <div class="container" data-aos="fade-up">

                    <div class="section-title">
                        <h2>{Translations.gallery[currentLanguage]}</h2>
                        <p>{Translations.galleryTitle[currentLanguage]}</p>
                    </div>

                    <div class="row content">
                        <div class="col-lg-12">
                            <p>
                                {Translations.galleryDescription[currentLanguage]}
                            </p>
                        </div>
                    </div>

                    <div class="row" data-aos="fade-up" data-aos-delay="100">
                        {
                            GalleryArray.map((item, index) => {
                                const id = `gallery-${index}`;

                                return (
                                    <>
                                        <div className="col-lg-4 col-md-6" key={index}>
                                            <div
                                                className="member"
                                                data-bs-toggle="modal"
                                                data-bs-target={`#${id}`}
                                            >
                                                <div className="pic">
                                                    <LazyImage
                                                        src={item.images[0]}
                                                        alt={item.name[currentLanguage]}
                                                    />
                                                </div>

                                                <div className="member-info">
                                                    <h4>{item.name[currentLanguage]}</h4>
                                                </div>
                                            </div>
                                        </div>

                                        <GalleryModal
                                            gallery={item}
                                            currentLanguage={currentLanguage}
                                            id={id}
                                        />
                                    </>
                                );
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default Gallery;